import { Injectable, Type } from '@angular/core';
import { ValueService } from '@kaiser-software/chassis-datatable/src/services/value.service';

interface Fields {
    detail: Type<any>,
    input: Type<any>,
    datatable?: Type<any>
}

@Injectable()
export class FieldService {
    protected fields: {
        [key: string]: Fields
    } = {};

    constructor(
        protected valueService: ValueService
    ) {

    }

    /**
     * Register a new field.
     *
     * @param name - The field name.
     * @param components - The field components to render.
     */
    public register(name: string, components: Fields): this {
        const fields = Object.assign({}, this.fields);
        fields[name] = components;
        this.fields  = fields;

        // Register in the datatable package
        if (components.datatable) {
            this.valueService.register(name, components.datatable);
        }

        return this;
    }

    /**
     * Get a field.
     *
     * @param name - The field name.
     * @param type - The type of field to retrieve
     */
    public get(name: string, type: 'detail' | 'input' | 'datatable'): Type<any> | null {
        return this.fields[name][type] || null;
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/resources/services/field.service.ts